import { call, put } from "redux-saga/effects";
import { musicsConstants } from "../actions/constants/musicsConstant";
import { exceptionHandler, exceptionHandlerForUpdate } from "../pages/common/functions";
import MusicPlatformService from "../services/api/musicPlatformService";
import { musicPlatformConstants } from "../actions/constants/musicPlatformConstant";

function* musicPlatformSave(request: any) {
	try {
		const result = yield call(MusicPlatformService.musicPlatformSave, request.input);
		var res = exceptionHandlerForUpdate(result);
		if (res.status) {
			yield put({
				type: musicPlatformConstants.MusicPlatformSaveSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: musicPlatformConstants.MusicPlatformSaveFailure, payload: res.data });
		}

	} catch (error) {
		yield put({ type: musicPlatformConstants.MusicPlatformSaveFailure, payload: error });
	}
}

function* musicPlatformGetDetail(request: any) {
	try {
		const result = yield call(
			MusicPlatformService.musicPlatformGetDetail,
			request.input
		);
		var res = exceptionHandler(result);

		if (res.status) {
			yield put({
				type: musicPlatformConstants.MusicPlatformDetailSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: musicPlatformConstants.MusicPlatformDetailFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: musicPlatformConstants.MusicPlatformDetailFailure,
			payload: e,
		});
	}
}

function* musicPlatformGetByfilter(request: any) {
	try {
		const result = yield call(MusicPlatformService.musicPlatformGetByFilter, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: musicPlatformConstants.MusicPlatformGetByfilterSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: musicPlatformConstants.MusicPlatformGetByfilterFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: musicPlatformConstants.MusicPlatformGetByfilterFailure,
			payload: e,
		});
	}
}

function* musicPlatformDelete(request: any) {
	try {
		const result = yield call(MusicPlatformService.musicPlatformDelete, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: musicPlatformConstants.MusicPlatformDeleteSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: musicPlatformConstants.MusicPlatformDeleteFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: musicPlatformConstants.MusicPlatformDeleteFailure,
			payload: error,
		});
	}
}

export const musicPlatformSaga = {
	musicPlatformGetDetail,
	musicPlatformGetByfilter,
	musicPlatformDelete,
	musicPlatformSave,
};
